// _           __   ___   _____    __   _   _   __   _   _____
// | |        / /  /   | |  _  \  |  \ | | | | |  \ | | /  ___|
// | |  __   / /  / /| | | |_| |  |   \| | | | |   \| | | |
// | | /  | / /  / / | | |  _  /  | |\   | | | | |\   | | |  _
// | |/   |/ /  / /  | | | | \ \  | | \  | | | | | \  | | |_| |
// |___/|___/  /_/   |_| |_|  \_\ |_|  \_| |_| |_|  \_| \_____/

// THIS FILE IS AUTO GENERATED!!!!!!
// DO NO EDIT IT HERE.

// THE TEMPLATE IS AT: tasks/pkg/icon-template/src/index.tsx

import baseIcon, { defaultIconGroupProps } from '@bubble-ui/temp-icon-base';
var IconRecurringPath = 'M5 2.053v-2H3v2H0v14a2 2 0 0 0 2 2h6.998v-2H2v-8h15v1.986h2V2.053h-3.012v-2h-2v2H5Zm12 4v-2H2v2h15Zm-4.9 5.853-.05-1.42-1.998.07.178 5.098 4.919-.322-.13-1.996-1.637.107a2.734 2.734 0 0 1 1.158-.637c1.453-.39 2.906.453 3.276 1.832.369 1.378-.468 2.835-1.92 3.224a2.698 2.698 0 0 1-2.711-.787 2.564 2.564 0 0 1-.279-.374L11.2 17.743c.146.24.313.462.497.667a4.697 4.697 0 0 0 4.717 1.384c2.483-.665 4-3.193 3.334-5.674-.664-2.481-3.24-3.912-5.725-3.246a4.731 4.731 0 0 0-1.922 1.032Z';
var IconRecurring = baseIcon('IconRecurring', {
  groupProps: defaultIconGroupProps,
  getPath: () => IconRecurringPath
});
export default IconRecurring;
//# sourceMappingURL=index.js.map